import React from 'react';
import { Heading, Person } from '@/components';
import type { PortableTextBlock as PortableTextBlockType, ImageAsset } from '@sanity/types';

interface ImageWithAlt {
  alt?: string;
  image: {
    asset: ImageAsset;
  };
}

interface PersonRole {
  name: string;
}

interface Person {
  firstName: string;
  lastName: string;
  nameOrder: 'firstLast' | 'lastFirst';
  photo: ImageWithAlt;
  personRole: PersonRole;
  shortBiography?: string;
  biography?: PortableTextBlockType;
  cahHeroType?: string;
  language: string;
}

interface PeopleGridProps {
  title?: string;
  people: Person[];
}

const PeopleGrid: React.FC<PeopleGridProps> = ({ title, people }) => {
  return (
    <div className='bg-sand-500'>
      <div className='font-halyarddisplay mx-auto max-w-screen-xl px-5 py-8 md:gap-x-6 md:p-[50px] lg:gap-x-12 xl:gap-x-24'>
        <div className='w-full'>
          {title && (
            <Heading
              title={title}
              className='mb-8'
            />
          )}
          <div className='grid grid-cols-1 gap-y-8 md:grid-cols-2 md:gap-x-[50px] lg:grid-cols-3 lg:gap-x-[93px]'>
            {people.map((person, index) => (
              <Person
                key={index}
                person={person}
                isLinkToPersonPage={true}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleGrid;
